/**
 * Testing utility to simulate slow loading conditions
 * Configure via .env file: VITE_TEST_AUTH_DELAY, VITE_TEST_API_DELAY, VITE_TEST_CLIENT_DATA_DELAY
 */

export const delay = (ms: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

const getEnvDelay = (type: 'auth' | 'api' | 'clientData'): number => {
  const envMap = {
    auth: import.meta.env.VITE_TEST_AUTH_DELAY,
    api: import.meta.env.VITE_TEST_API_DELAY,
    clientData: import.meta.env.VITE_TEST_CLIENT_DATA_DELAY,
  };

  const value = envMap[type];
  const numValue = parseInt(value, 10);
  return isNaN(numValue) ? 0 : numValue;
};

export const applyTestDelay = async (type: 'authDelay' | 'apiDelay' | 'clientDataDelay'): Promise<void> => {
  const typeMap = {
    authDelay: 'auth' as const,
    apiDelay: 'api' as const,
    clientDataDelay: 'clientData' as const,
  };

  const delayMs = getEnvDelay(typeMap[type]);

  if (delayMs > 0) {
    console.log(`⏱️ Test delay (${type}): ${delayMs}ms`);
    await delay(delayMs);
  }
};
